import { disabledTimeListsProps as r } from "./index634.js";
import { buildProps as o, definePropType as e } from "./index601.js";
const p = o({
  role: {
    type: String,
    required: !0
  },
  spinnerDate: {
    type: e(Object),
    required: !0
  },
  showSeconds: {
    type: Boolean,
    default: !0
  },
  arrowControl: Boolean,
  amPmMode: {
    // 'a': am/pm; 'A': AM/PM
    type: e(String),
    default: ""
  },
  ...r
});
export {
  p as basicTimeSpinnerProps
};
